import React, { useContext, useState } from 'react'
import { Typography, Box, Menu, MenuItem, ListItemText, Switch } from "@mui/material";
import AdsClickOutlinedIcon from '@mui/icons-material/AdsClickOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import { InfoOutlined } from "@mui/icons-material";
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import ArrowRight from '@mui/icons-material/ArrowRight';
import { ThemeContext } from '../../context/ThemeContext';
import TranslateIcon from '@mui/icons-material/Translate';
import { useTranslation } from 'react-i18next';
import ContactUs from '../contactUS/ContactUS';
import OneClickTrading from '../modal/OneClickTrading';
import CheckIcon from '@mui/icons-material/Check';
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import CompanyInfoPage from './CompanyInfoPage';
import { useDispatch, useSelector } from 'react-redux';
import { setIsUserSigned } from '../../store/Slices/watchList';

export default function UserMenu({ anchorEl, darkMode, id, client, handleClose, handleLogout, accountData }) {
  const [submenuAnchorEl, setSubmenuAnchorEl] = useState(null);
  const [hoverSubmenu, setHoverSubmenu] = useState(null);
  const { toggleTheme, setDirection } = useContext(ThemeContext)
  const { i18n, t } = useTranslation();
  const [isContactUsOpen, setIsContactUsOpen] = useState(false);
  const [isDisclamerOpen, setIsDisclamerOpen] = useState(false);
  const [isCompanyDetailOpen, setIsCompanyDetailOpen] = useState(false);
  const [hasAcceptedDisclaimer, setHasAcceptedDisclaimer] = useState(false);  // Track if user accepted the disclaimer
  const isOneClick = useSelector(state => state.watchlist?.isOneclick)
  const hasAgreed = useSelector(state => state?.watchlist?.isUserSigned)
  const dispatch = useDispatch()
  const handleSubmenuOpen = (event, menu) => {
    setHoverSubmenu(menu);
    setSubmenuAnchorEl(event.currentTarget);
  };

  const handleSubmenuClose = () => {
    setHoverSubmenu(null);
    setSubmenuAnchorEl(null);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);
    setDirection(lng === 'ar' ? 'rtl' : 'ltr');
    document.dir = lng === 'ar' ? 'rtl' : 'ltr';
    setSubmenuAnchorEl(null);
    handleClose();
  };

  const handleOpenContactUs = () => {
    setIsContactUsOpen(true);
    handleClose();
  };

  const handleCloseContactUs = () => {
    setIsContactUsOpen(false);
  };
  const handleOpenDisclamer = () => {
    setIsDisclamerOpen(true);
    handleClose(); // Close the user menu when opening the modal
  };

  const handleCloseDisclamer = () => {
    setIsDisclamerOpen(false);
  };
  const handleAcceptDisclaimer = () => {
    setHasAcceptedDisclaimer(true);
    dispatch(setIsUserSigned(true));

  };
  const handleOpenCompanyDetail = () => {
    setIsCompanyDetailOpen(true);
    handleClose();
  };
  const handleCloseCompanyDetail = () => {
    setIsCompanyDetailOpen(false);
  };
const handleOneClickToggle = (e) => {
  e.stopPropagation();

  const isCurrentlyEnabled = hasAgreed;

  if (!isCurrentlyEnabled) {
    handleOpenDisclamer();
  } else {
    const agreementKey = `oneClickTradingAgreement_${client?.id}`;
    localStorage.removeItem(agreementKey);
    setHasAcceptedDisclaimer(false);
    dispatch(setIsUserSigned(false));
    setIsDisclamerOpen(false);
  }
};


  return (
    <>
      <Menu sx={{ "& .MuiList-root": { padding: 0 }, }} anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }} PaperProps={{ elevation: 5, }} >
        <Box width={"250px"} p={1} key={id} data-summary={id} sx={{ backgroundColor: darkMode ? "#273649" : 'var(--white)', }}>
          {accountData?.demoAccount && <div className="ribbon"> {t('demo')}</div>}
          <ListItemText
            sx={{ pl: 2, }} primary={`${client.userName || client.username || "Guest"}`} />

          <Typography sx={{ pl: 2, fontSize: 13, }} noWrap > {id || "N/A"}<i> - {process.env.REACT_APP_COMPANY_NAME} {accountData?.demoAccount && "- DEMO"}</i></Typography>
          <Box mt={2} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}>

            <MenuItem sx={{ fontSize: 13.5, marginBottom: '2px' }}><AdsClickOutlinedIcon sx={{ fontSize: 20, marginRight: 1 }} />{t('oneClickTrading')}
              <Switch size="small" checked={hasAgreed} onClick={(e) => e.stopPropagation()} onChange={handleOneClickToggle} sx={{ marginLeft: "auto" }}/>
            </MenuItem>

            <MenuItem onClick={() => { toggleTheme(); handleClose(); }} sx={{ fontSize: 13.5, marginBottom: '2px' }}>
              {!darkMode ? (<><DarkModeOutlinedIcon sx={{ fontSize: 20, marginRight: 1 }} />{t('darkTheme')}</>) : (<><LightModeOutlinedIcon sx={{ fontSize: 20, marginRight: 1 }} />{t('lightTheme')}</>)}
            </MenuItem>
            <MenuItem onClick={(e) => handleSubmenuOpen(e, "languageSettings")} sx={{ fontSize: 13.5, marginBottom: '2px' }}> <TranslateIcon sx={{ fontSize: 20, marginRight: 1 }} />{t('language')}  <ArrowRight sx={{ marginLeft: "auto", fontSize: '1.1rem' }} /></MenuItem>
            {hoverSubmenu === "languageSettings" && (
              <Menu sx={{ "& .MuiList-root": { padding: 0 }, }} anchorEl={submenuAnchorEl} open={hoverSubmenu === "languageSettings"} onClose={handleSubmenuClose} anchorOrigin={{ vertical: "top", horizontal: "right" }} MenuListProps={{ onMouseLeave: handleSubmenuClose, }}
                transformOrigin={{ vertical: "top", horizontal: "left" }} >
                <Box sx={{ backgroundColor: darkMode ? "#273649" : 'var(--white)' }} p={1} >
                  <MenuItem sx={{ fontSize: 13.5, color: darkMode ? "var(--lightText)" : 'var(--darkText)' }} onClick={() => changeLanguage('en')}>{t('english')} (English)</MenuItem>
                  <MenuItem sx={{ fontSize: 13.5, color: darkMode ? "var(--lightText)" : 'var(--darkText)' }} onClick={() => changeLanguage('ar')}>{t('arabic')} (العربية)</MenuItem>
                  <MenuItem sx={{ fontSize: 13.5, color: darkMode ? "var(--lightText)" : 'var(--darkText)' }} onClick={() => changeLanguage('hi')}>{t('hindi')} (हिन्दी)</MenuItem>
                </Box>
              </Menu>
            )}

            <MenuItem sx={{ fontSize: 13.5, marginBottom: '2px' }} onClick={() => { handleClose(); window.open(process.env.REACT_APP_HELP_PAGE_URL, '_blank') }}><HelpOutlineOutlinedIcon sx={{ fontSize: 20, marginRight: 1 }} />{t("help")}</MenuItem>
            <MenuItem sx={{ fontSize: 13.5, marginBottom: '2px' }} onClick={() => { handleClose(); window.open(process.env.REACT_APP_PRIVACY_POLICY_URL, '_blank') }}><PolicyOutlinedIcon sx={{ fontSize: 20, marginRight: 1 }} />{t("privacyPolicy")}</MenuItem>
            <MenuItem sx={{ fontSize: 13.5, marginBottom: '2px' }} onClick={() => { handleClose(); window.open(process.env.REACT_APP_TERMS_OF_SERVICE_URL, '_blank') }} ><TextSnippetOutlinedIcon sx={{ fontSize: 20, marginRight: 1 }} />{t("termcondition")}</MenuItem>
            <MenuItem sx={{ fontSize: 13.5, marginBottom: '2px' }} onClick={handleOpenContactUs}><ChatBubbleOutlineOutlinedIcon sx={{ fontSize: 20, marginRight: 1 }} />{t('contactUs')}</MenuItem>
            <MenuItem sx={{ fontSize: 13.5, marginBottom: '2px' }} onClick={handleOpenCompanyDetail}><InfoOutlined sx={{ fontSize: 20, marginRight: 1 }} />{t('about')}</MenuItem>
            <MenuItem sx={{ fontSize: 13.5, marginBottom: '2px' }} onClick={handleLogout}><LogoutOutlinedIcon sx={{ fontSize: 20, marginRight: 1 }} />{t('logout')}</MenuItem>
          </Box>
        </Box>
      </Menu>
      {isContactUsOpen && <ContactUs isOpen={isContactUsOpen} onClose={handleCloseContactUs} />}
      {isDisclamerOpen && <OneClickTrading isOpen={isDisclamerOpen} onClose={handleCloseDisclamer} onAccept={handleAcceptDisclaimer} />}
      {isCompanyDetailOpen && <CompanyInfoPage isOpen={isCompanyDetailOpen} onClose={handleCloseCompanyDetail} />}
    </>)
}